import script from "./SellerReviewsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerReviewsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerReviewsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__